import { Component, ChangeDetectorRef } from '@angular/core';
import { AlertController, ModalController, NavController, NavParams, ViewController} from 'ionic-angular';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";
import { ReportSearchUnitmodelPage } from "../report-search-unitmodel/report-search-unitmodel";
import { DataService } from "../../services/data.service";
import { ReportSelectUnitPage } from "../report-select-unit/report-select-unit";
import { InfoModalPage } from "../info-modal/info-modal";
import { ReportSelectUnitbrandPage } from "../report-select-unitbrand/report-select-unitbrand";
import { Camera } from "@ionic-native/camera";
import {ApiService} from "../../services/api.service";
import {FileService} from "../../services/file.service";
import {ViewPhotoPage} from "../view-photo/view-photo";
import {ReportService} from "../../services/report.service";

@Component({
  selector: 'page-add-unit',
  templateUrl: 'report-add-unit.html',
})
export class ReportAddUnitPage {

  units = [];
  parent: ReportSelectUnitPage;
  unitType = 1;
  workorderType = 0;
  data: any;
  photos = [];
  files = [];
  unitForm: FormGroup;
  allowWarranty = false;
  saving = false;
  allRequired = true;
  country = 'NL';

  children = [];
  childForms: Array<FormGroup> = [];

  unitTypeInfoHtml = '<table><tr><td colspan="4"><strong>VST 1 voorheen A</strong></td></tr><tr><td>Verblijfsruimte</td><td>Toevoer</td><td>Natuurlijk</td><td>Direct</td></tr><tr><td></td><td>Afvoer</td><td>Natuurlijk</td><td>Indirect</td></tr><tr><td>Natte ruimte</td><td>Toevoer</td><td>Natuurlijk</td><td>Direct</td></tr><tr><td></td><td>Afvoer</td><td>Natuurlijk</td><td>Indirect</td></tr><tr><td colspan="4"><strong>VST 2 voorheen B</strong></td></tr><tr><td>Verblijfsruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td></td><td>Afvoer</td><td>Natuurlijk</td><td>Direct</td></tr><tr><td>Natte ruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td></td><td>Afvoer</td><td>Natuurlijk</td><td>Direct</td></tr><tr><td colspan="4"><strong>VST 3 voorheen C</strong></td></tr><tr><td>Verblijfsruimte</td><td>Toevoer</td><td>Natuurlijk</td><td>Direct</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td>Natte ruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td colspan="4"><strong>VST 4 voorheen C 4c</strong></td></tr><tr><td>Verblijfsruimte</td><td>Toevoer</td><td>Natuurlijk</td><td>Direct</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td>Natte ruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td colspan="4"><strong>VST 5 voorheen D</strong></td></tr><tr><td>Verblijfsruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td>Natte ruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td colspan="4"><strong>VST 6 voorheen D</strong></td></tr><tr><td>Verblijfsruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td>Natte ruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td colspan="4"><strong>VST 7 voorheen E (X)</strong></td></tr><tr><td>Verblijfsruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Direct</td></tr><tr><td>Natte ruimte</td><td>Toevoer</td><td>Mechanisch</td><td>Indirect</td></tr><tr><td></td><td>Afvoer</td><td>Mechanisch</td><td>Direct</td></tr></table>';

  datePickerOptions: any = {
    buttons: [{
      text: 'Leeg maken',
      handler: () => {
        this.unitForm.controls['time_installation'].setValue(null);
      }
    }]
  };

  datePickerOptionsExhaustCheck: any = {
    buttons: [{
      text: 'Leeg maken',
      handler: () => {
        this.unitForm.controls['time_next_exhaust_check'].setValue(null);
      }
    }]
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public modalCtrl: ModalController,
    public viewCtrl: ViewController,
    public changeDetector: ChangeDetectorRef,
    public barcodeScanner: BarcodeScanner,
    public dataService: DataService,
    public camera: Camera,
    public fileService: FileService,
    public reportService: ReportService,
    public alertCtrl: AlertController,
    public apiService: ApiService
  ) {
    this.data = this.reportService.getData();
    this.workorderType = parseInt(this.data.workorder_type);
    this.saving = false;
    this.parent = this.navParams.get('parent');
    this.unitType = parseInt(this.navParams.get('unitType'));
    // Set allowWarranty
    this.setAllowWarranty(false);
    // Init form
    this.initForm();
    this.initChildren();
  }

  initForm(){
    let currentYear = new Date().getFullYear();
    if(this.workorderType == 7){
      this.allRequired = false;
    }
    // Set country
    if (this.data.customers.client && this.data.customers.client.country) {
      this.country = this.data.customers.client.country;
    }
    // CV
    if(this.unitType === 1){
      this.unitForm = this.formBuilder.group({
        unit_brand: ['', Validators.required],
        unit_brand_id: [''],
        unit_model: ['', Validators.required],
        unit_model_id: [''],
        unit_version: [''],
        unit_version_id: [''],
        serial_nr: ['', Validators.required],
        passport_nr: ['', Validators.required],
        unit_nr: [''],
        year: ['', Validators.compose([Validators.required, Validators.min(1900), Validators.max(currentYear)])],
        nominal_power: ['', (this.allRequired ? Validators.required : null)],
        openings: ['Ja', (this.allRequired ? Validators.required : null)],
        fuel_type: ['Aardgas'],
        cascade: ['Nee'],
        unit_type: 'HR',
        exhaust_type: ['', (this.allRequired ? Validators.required : null)],
        exhaust_replaced: [''],
        exhaust_location: [''],
        service_interval: ['', (this.allRequired ? Validators.required : null)],
        contract_nr: [''],
        plan_code: ['4'],
        time_installation: [''],
        time_next_exhaust_check: [''],
        warranty: [''],
        extended_warranty: [''],
        extended_warranty_duration: [''],
        extended_warranty_contact: [''],
        co_detector: [''],
        co_detector_year: ['', Validators.compose([Validators.min(1900), Validators.max(currentYear)])],
        burner_brand: [''],
        burner_type: [''],
        burner_year: ['', Validators.compose([Validators.min(1900), Validators.max(currentYear)])],
        burner_serial_nr: [''],
        burner_flow_rate_unit: [''],
        burner_flow_rate_value: [''],
        sprinkler_brand: [''],
        sprinkler_type: [''],
        sprinkler_flow_rate_unit: [''],
        sprinkler_flow_rate_value: [''],
        sprinkler_angle: [''],
      });
    }
    // Ventilatie
    if(this.unitType === 2){
      this.unitForm = this.formBuilder.group({
        unit_brand: ['', Validators.required],
        unit_brand_id: [''],
        unit_model: ['', Validators.required],
        unit_model_id: [''],
        unit_version: [''],
        unit_version_id: [''],
        serial_nr: ['', Validators.required],
        passport_nr: ['', Validators.required],
        unit_nr: [''],
        year: ['', Validators.compose([Validators.required, Validators.min(1900), Validators.max(currentYear)])],
        unit_type: 'Natuurlijke toe- en afvoer',
        capacity: '',
        filter_type: '',
        password: '',
        ventilation_setting0: '',
        ventilation_setting1: '',
        ventilation_setting2: '',
        ventilation_setting3: '',
        ventilation_setting4: '',
        ventilation_setting5: '',
        control_type: '',
        co2_detector: [''],
        hygro_detector: [''],
        service_interval: ['', Validators.required],
        contract_nr: [''],
        plan_code: ['4'],
        time_installation: [''],
        warranty: [''],
        extended_warranty: [''],
        extended_warranty_duration: [''],
        extended_warranty_contact: ['']
      });
    }
    // Waterontharder
    if(this.unitType === 3){
      this.unitForm = this.formBuilder.group({
        unit_brand: ['', Validators.required],
        unit_brand_id: [''],
        unit_model: ['', Validators.required],
        unit_model_id: [''],
        unit_version: [''],
        unit_version_id: [''],
        serial_nr: ['', Validators.required],
        passport_nr: ['', Validators.required],
        unit_nr: [''],
        maximum_capacity: [''],
        daily_capacity: [''],
        unit_location: [''],
        resin_content: [''],
        salt_usage: [''],
        unit_usage: [''],
        not_softened: [''],
        year: ['', Validators.compose([Validators.required, Validators.min(1900), Validators.max(currentYear)])],
        backwash: [''],
        sucking: [''],
        flushing: [''],
        filling1: [''],
        filling2: [''],
        set_flushing_time: [''],
        valve_voltage: [''],
        service_interval: ['', Validators.required],
        regeneration_time1: [''],
        regeneration_time2: [''],
        regeneration_time3: [''],
        regeneration_time4: [''],
        regeneration_time5: [''],
        software_version: [''],
        regulation_type: [''],
        password: [''],
        operation_type: [''],
        contract_nr: [''],
        plan_code: ['4'],
        time_installation: [''],
        warranty: [''],
        extended_warranty: [''],
        extended_warranty_duration: [''],
        extended_warranty_contact: [''],
      });
    }
    // Hijstoestel
    if(this.unitType === 4){
      this.unitForm = this.formBuilder.group({
        unit_brand: ['', Validators.required],
        unit_brand_id: [''],
        unit_model: ['', Validators.required],
        unit_model_id: [''],
        unit_version: [''],
        unit_version_id: [''],
        certificate_nr: ['EN13155'],
        serial_nr: ['', Validators.required],
        passport_nr: ['', Validators.required],
        unit_nr: [''],
        unit_location: [''],
        nominal_load: [''],
        year: ['', Validators.compose([Validators.required, Validators.min(1900), Validators.max(currentYear)])],
        service_interval: ['', Validators.required],
        contract_nr: [''],
        plan_code: ['4'],
        time_installation: [''],
        warranty: [''],
        extended_warranty: [''],
        extended_warranty_duration: [''],
        extended_warranty_contact: [''],
      });
    }
    // Airco
    if(this.unitType === 5) {
      this.unitForm = this.formBuilder.group({
        unit_brand: ['', Validators.required],
        unit_brand_id: [''],
        unit_model: ['', Validators.required],
        unit_model_id: [''],
        unit_version: [''],
        unit_version_id: [''],
        serial_nr: ['', Validators.required],
        passport_nr: ['', Validators.required],
        unit_nr: [''],
        year: ['', Validators.compose([Validators.required, Validators.min(1900), Validators.max(currentYear)])],
        outside_unit_location: [''],
        coolant_type: [''],
        power: [''],
        nominal_coolant_level: [''],
        additional_coolant_amount: [''],
        total_coolant_amount: [''],
        regulation_type: [''],
        service_interval: ['', Validators.required],
        time_installation: [''],
        password: [''],
        contract_nr: [''],
        plan_code: ['4'],
        warranty: [''],
        extended_warranty: [''],
        extended_warranty_duration: [''],
        extended_warranty_contact: [''],
      });
    }
    // Gasleiding
    if(this.unitType === 7) {
      this.unitForm = this.formBuilder.group({
        unit_brand: ['', Validators.required],
        unit_brand_id: [''],
        unit_model: ['', Validators.required],
        unit_model_id: [''],
        unit_version: [''],
        unit_version_id: [''],
        serial_nr: ['', Validators.required],
        passport_nr: ['', Validators.required],
        unit_nr: [''],
        year: ['', Validators.compose([Validators.required, Validators.min(1900), Validators.max(currentYear)])],
        location_gas_meter: [''],
        part_checked: [''],
        piping_not_visible: [''],
        materials_used: [''],
        piping_fitted: [''],
        piping_covered: [''],
        piping_protected: [''],
        contract_nr: [''],
        plan_code: ['4'],
      });
    }
    // Algemeen
    if(this.unitType === 8) {
      this.unitForm = this.formBuilder.group({
        general_unit_type: ['', Validators.required],
        unit_brand: ['', Validators.required],
        unit_brand_id: [''],
        unit_model: ['', Validators.required],
        unit_model_id: [''],
        unit_version: [''],
        unit_version_id: [''],
        serial_nr: [''],
        passport_nr: [''],
        unit_nr: [''],
        contract_nr: [''],
        plan_code: [''],
        notes: [''],
      });
    }
    // Gas- of sfeerhaard
    if(this.unitType === 9){
      this.unitForm = this.formBuilder.group({
        unit_brand: ['', Validators.required],
        unit_brand_id: [''],
        unit_model: ['', Validators.required],
        unit_model_id: [''],
        unit_version: [''],
        unit_version_id: [''],
        serial_nr: ['', Validators.required],
        passport_nr: ['', Validators.required],
        unit_nr: [''],
        year: ['', Validators.compose([Validators.required, Validators.min(1900), Validators.max(currentYear)])],
        nominal_power: ['', (this.allRequired ? Validators.required : null)],
        openings: ['Ja', (this.allRequired ? Validators.required : null)],
        fuel_type: ['Aardgas'],
        exhaust_location: [''],
        service_interval: ['', (this.allRequired ? Validators.required : null)],
        contract_nr: [''],
        plan_code: ['4'],
        time_installation: [''],
        co_detector: [''],
        co_detector_year: ['', Validators.compose([Validators.min(1900), Validators.max(currentYear)])]
      });
    }
  }

  initChildren(){
    let currentYear = new Date().getFullYear();
    // Init childForms
    this.childForms = [];
    for(let child of this.children) {
      let form = null;
      switch(child.unit_model_unit_type) {
        case 6:
          // Volumestromen ventilatietoevoer (type = 201)
          form = this.formBuilder.group({
            room: [''],
            floor: [''],
            unit_brand: ['', Validators.required],
            unit_brand_id: [''],
            unit_model: ['', Validators.required],
            unit_model_id: [''],
            unit_version: [''],
            unit_version_id: [''],
            serial_nr: ['', Validators.required],
            passport_nr: ['', Validators.required],
            unit_nr: [''],
            year: ['', Validators.compose([Validators.required, Validators.min(1900), Validators.max(currentYear)])],
            inside_unit_location: [''],
            notes: [''],
            service_interval: ['', Validators.required],
            time_installation: [''],
            plan_code: ['4'],
          });
          break;
      }
      if(form) {
        form.patchValue(child);
        this.childForms.push(form);
      }
    }
  }


  setAllowWarranty(value: boolean){
    // Set allowWarranty bij '1e inbedrijfstelling (1)' en 'Aanmelden nieuwe installatie (5)' en geen actieve EDUCATIE subscription
    if(
      (this.parent.data.workorder_type == '1' || this.parent.data.workorder_type == '5')
      && !this.apiService.hasActiveSubscription('EDUCATIE')
      && value === true
    ) {
      this.allowWarranty = true;
    } else {
      this.allowWarranty = false;
    }
  }

  searchUnitmodel(){
    this.modalCtrl.create(ReportSearchUnitmodelPage, {
      unitType: this.unitType,
      reportAddUnitPage: this,
      form: this.unitForm
    }).present();
  }

  selectBrand(){
    this.modalCtrl.create(ReportSelectUnitbrandPage, {
      reportAddUnitPage: this,
      form: this.unitForm
    }).present();
  }

  scanBarcode(field, form?: FormGroup){
    if(!form){
      form = this.unitForm;
    }
    this.barcodeScanner.scan({
      showTorchButton: true,
      torchOn: true
    }).then(data => {
      console.log('Barcode data', data);
      let barcode = data.text;
      if(field == 'passport_nr' && barcode.lastIndexOf('/') > 0){
        barcode = barcode.substring(barcode.lastIndexOf('/')+1);
      }
      if(barcode){
        if(field == 'passport_nr' && this.apiService.hasActiveSubscription('EDUCATIE') && barcode.substr(0, 2) != 'TE') {
          this.alertCtrl.create({
            title: 'TE nummer',
            message: 'U heeft een educatie licentie. Hiermee kunt u alleen stickers gebruiken die een TE nummer hebben.',
            buttons: ['OK']
          }).present();
        } else {
          form.get(field).setValue(barcode);
          if(field == 'passport_nr'){
            this.onPassportNrChange();
            // Waarschuwing TE sticker bij account zonder EDUCATIE licentie
            if(!this.apiService.hasActiveSubscription('EDUCATIE') && barcode.substr(0, 2) == 'TE') {
              this.alertCtrl.create({
                title: 'TE nummer',
                message: 'U heeft een TE sticker gescand, terwijl u geen educatie licentie heeft. Neem contact op met Maintenanz om de juiste stickers te bestellen.',
                buttons: ['OK']
              }).present();
            }
          }
        }
      }
    }).catch(err => {
      console.log('Error', err);
    });
  }

  onPassportNrChange(){
    let barcode = this.unitForm.get('passport_nr').value;
    if(barcode){
      this.apiService.checkQr(barcode).then((data) => {
        if(data > 0){
          this.alertCtrl.create({
            title: 'Waarschuwing',
            message: 'Dit installatiepas nummer is al in gebruik bij een andere installatie.',
            buttons: ['OK']
          }).present();
        }
      }).catch((err) => {
        console.error(err);
      });
    }
  }

  onUnitTypeSelect(value){
    // Als unit_type == 'Atmosferische ketel', exhaust_type instellen op 'Open toestel type B'
    if (value == 'Atmosferische ketel') {
      this.unitForm.get('exhaust_type').setValue('Open toestel type B');
    }
  }

  onFuelTypeSelect(value){
    // Als fuel_type == 'Stookolie / Mazout', service_interval instellen op '12'
    if (value == 'Stookolie / Mazout') {
      this.unitForm.get('service_interval').setValue('12');
    }
  }

  onTimeInstallationChange(){
    // time_next_exhaust_check invullen met time_installation + 15 jaar
    let value = this.unitForm.get('time_installation').value;
    let year = parseInt(value.substr(0, 4));
    let time_next_exhaust_check = (year + 15) + value.substr(4, 6);
    this.unitForm.get('time_next_exhaust_check').setValue(time_next_exhaust_check);
  }

  addPhoto() {
    this.alertCtrl.create({
      title: 'Foto toevoegen',
      cssClass: 'alert-not-bold',
      buttons: [
        {
          text: 'Nieuwe foto maken',
          handler: () => {
            this.getPicture(this.camera.PictureSourceType.CAMERA);
          }
        },
        {
          text: 'Kies foto uit fotoalbum',
          handler: () => {
            this.getPicture(this.camera.PictureSourceType.PHOTOLIBRARY);
          }
        }
      ]
    }).present();
  }

  getPicture(sourceType){
    this.camera.getPicture({
      quality: 60,
      targetWidth: 1200,
      targetHeight: 1200,
      correctOrientation: true,
      sourceType: sourceType,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE
    }).then((imageData) => {
      let src = 'data:image/jpeg;base64,' + imageData;
      if(this.unitType == 1){
        this.alertCtrl.create({
          title: 'Foto',
          inputs: [
            {
              name: 'title',
              type: 'radio',
              label: 'Met kap',
              value: 'Met kap'
            },
            {
              name: 'title',
              type: 'radio',
              label: 'Zonder kap',
              value: 'Zonder kap'
            }
          ],
          buttons: [
            {
              text: 'Annuleren',
              role: 'cancel'
            },
            {
              text: 'OK',
              handler: (data) => {
                this.photos.push({
                  title: data,
                  src: src
                });
              }
            }
          ]
        }).present();
      } else {
        this.photos.push({
          title: '',
          src: src
        });
        this.uploadPhotos();
      }
    }, (err) => {
      this.changeDetector.detectChanges();
    });
  }

  addFile(){
    this.fileService.getFile().then((file) => {
      this.files.push(file);
      this.uploadFiles();
    }).catch((error) => {
      this.changeDetector.detectChanges();
      if(error == -1){
        this.alertCtrl.create({
          title: 'Bestand te groot',
          message: 'Dit bestand is te groot. Het bestand mag maximaal ' + this.fileService.maxFileSizeMegaBytes + 'MB groot zijn',
          buttons: ['OK']
        }).present();
      }
    });
  }

  viewPhoto(photo, index){
    this.modalCtrl.create(ViewPhotoPage, {
      photo: photo,
      photos: this.photos,
      index: index
    }, {
      cssClass: 'modal-fullscreen'
    }).present();
  }

  removeFile(index, filename){
    this.alertCtrl.create({
      title: 'Bestand verwijderen',
      message: 'Wilt u bestand \'' + filename + '\' verwijderen?',
      buttons: [
        {
          text: 'Nee',
          role: 'cancel'
        },{
          text: 'Ja',
          handler: () => {
            this.files.splice(index, 1);
          }
        }
      ]
    }).present();
  }

  saveFormsToChildren(){
    if(this.children.length === 0){
      return;
    }
    let i = 0;
    for(let child of this.children){
      Object.assign(child, this.childForms[i].value);
      i++;
    }
  }

  addChild(type){
    this.saveFormsToChildren();
    this.children.push({
      _unit_id: 'n' + new Date().getTime(),
      unit_model_unit_type: type,
      status: 1
    });
    this.initChildren();
  }

  deleteChild(index){
    this.saveFormsToChildren();
    if (index > -1) {
      this.children.splice(index, 1);
    }
    this.initChildren();
  }

  isValid(){
    if(!this.unitForm.valid){
      return false;
    }
    for(let index = 0; index < this.children.length; index++){
      let form: FormGroup = this.childForms[index];
      if(!form.valid){
        return false;
      }
    }
    return true;
  }

  showBurnerFields(){
    const unit_type = this.unitForm.get('unit_type').value;
    const fuel_type = this.unitForm.get('fuel_type').value;
    if(unit_type == 'Gasketel met ventilator brander' || fuel_type == 'Stookolie / Mazout'){
      return true;
    }
    return false;
  }

  save(){
    if(!this.saving && this.isValid()){
      this.saving = true;
      this.changeDetector.detectChanges();
      this.saveFormsToChildren();
      let unit = this.unitForm.value;
      unit._unit_id = 'n' + new Date().getTime();
      unit.list_title = unit.unit_brand + ' ' + unit.unit_model + ' ' + unit.unit_version;
      unit.list_subtitle = unit.passport_nr;
      if(unit.cascade && unit.cascade != 'Nee'){
        if(unit.list_subtitle) unit.list_subtitle += ' ';
        unit.list_subtitle += 'Cascade: ' + unit.cascade;
      }
      unit.status = 1;
      unit.photos = this.photos;
      unit.files = this.files;
      unit.children = this.children;
      unit.unit_model_unit_type = this.unitType;
      this.parent.units.push(unit);
      this.parent.selectUnit(unit);
      this.parent.sortUnits();
      setTimeout(() => {
        this.closeModal();
      }, 1000);
    }
  }

  closeModal(){
    this.viewCtrl.dismiss();
  }

  openInfo(title, text){
    this.modalCtrl.create(InfoModalPage, {
      title: title,
      text: text
    }).present();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ReportAddUnitPage');
  }

  onSelectOther(event, field_name: string, mapping_array?){
    if(event == '-'){
      let field = this.unitForm.get(field_name);
      field.setValue('');
      this.alertCtrl.create({
        title: 'Anders...',
        inputs: [
          {
            name: 'input_value',
            placeholder: 'Vul in'
          }
        ],
        buttons: [
          {
            text: 'Annuleren',
            role: 'cancel'
          },
          {
            text: 'OK',
            handler: (data) => {
              if (data.input_value) {
                field.setValue(data.input_value);
                if(mapping_array){
                  mapping_array.push(data.input_value);
                }
              } else {
                return false;
              }
            }
          }
        ]
      }).present();
    }
  }

  uploadPhotos() {
    for (let photo of this.photos) {
      if (!photo.file_id) {
        this.apiService.uploadPhoto(photo.src, 'unit').then((data: any) => {
          photo.file_id = data.file_id;
          photo.token = data.token;
          photo.src = data.display_url;
          photo._new_file = true;
        }).catch((error) => {
          console.error(error);
        });
      }
    }
  }

  uploadFiles() {
    for (let file of this.files) {
      if (!file.file_id) {
        this.apiService.uploadFile(file.src, file.filename, 'unit').then((data: any) => {
          file.file_id = data.file_id;
          file.token = data.token;
          file.src = data.display_url;
          file._new_file = true;
        }).catch((error) => {
          console.error(error);
        });
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/report-add-unit/report-add-unit.ts